/// <amd-module name="Dashboards/Common/Constants" />
export const DisableUserNamePrefixForProjectDashboardFeature = "ms.vss-dashboards-web.project-level-dashboard-disable-user-prefix-feature";
